export default __webpack_public_path__ + "static/media/closered.7309e84d.svg";